import { Controller } from 'stimulus';

/* Blocks file attachments (like pasted images) in Trix editors.
   Usage: Add data-controller="trix-no-attachments" either directly to a
   trix-editor element, or to an ancestor of one (e.g. the simple_form
   wrapper div around a rich_text_area input) - Trix's file/paste events
   bubble, so a listener on either works. */

export default class TrixNoAttachmentsController extends Controller {
  connect() {
    this.editorElement = this.findEditorElement();

    this.preventFileAttachment = this.preventFileAttachment.bind(this);
    this.preventImagePaste = this.preventImagePaste.bind(this);
    this.handleNativePaste = this.handleNativePaste.bind(this);

    this.element.addEventListener('trix-file-accept', this.preventFileAttachment);
    this.element.addEventListener('trix-paste', this.preventImagePaste);
    this.element.addEventListener('paste', this.handleNativePaste, true);
  }

  findEditorElement() {
    return this.element.closest('trix-editor') || this.element.querySelector('trix-editor');
  }

  disconnect() {
    this.element.removeEventListener('trix-file-accept', this.preventFileAttachment);
    this.element.removeEventListener('trix-paste', this.preventImagePaste);
    this.element.removeEventListener('paste', this.handleNativePaste, true);
  }

  preventFileAttachment(event) {
    event.preventDefault();
  }

  preventImagePaste(event) {
    const html = event.paste?.html;
    if (!html) return;

    if (!/<img\b[^>]*>/i.test(html)) return;

    event.preventDefault();

    const text = event.paste?.text;
    if (!text) return;

    if (this.editorElement?.editor?.insertString) {
      this.editorElement.editor.insertString(text);
    }
  }

  handleNativePaste(event) {
    const clipboardData = event.clipboardData;
    if (!clipboardData) return;

    const html = clipboardData.getData('text/html');
    if (!html) return;

    // Covers:
    // - data: image pastes (<img src="data:image/...">)
    // - remote image embeds (<figure><img src="https://...">)
    if (!/(<img\b[^>]*>|<figure\b[^>]*>)/i.test(html)) return;

    event.preventDefault();

    const text = clipboardData.getData('text/plain');
    if (!text) return;

    if (this.editorElement?.editor?.insertString) {
      this.editorElement.editor.insertString(text);
      return;
    }

    document.execCommand('insertText', false, text);
  }
}
